import React from 'react'
import { NavLink as ReachLink } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { Helmet } from 'react-helmet'

// Load Chakra
import { Box, Image, LinkOverlay, LinkBox, Heading } from '@chakra-ui/react'

// Get the right logo
import logo from '../../component/UI/Logo/Logo'
import scratchcardImg from 'img/banner-rayadito.png'

// FE Library
import { useLanguageContext } from 'component/Translations/Translations'

// Load Components
import Text from '../../component/UI/Text/Text'
import Hero from '../../component/UI/Hero/Hero'
import RecentDrawsList from 'component/RecentDrawsList/RecentDrawsList'

// Load templates
import LayoutBase from '../../template/LayoutBase.page'
import ErrorBoundary from '../../component/Errors/ErrorBoundary'

const HomePage = () => {
    // Translation hook
    const { getText } = useLanguageContext()

    return (
        <Sentry.ErrorBoundary
            beforeCapture={(scope) => {
                scope.setTag('Lottery-fe', 'Homepage')
            }}
            fallback={() => <ErrorBoundary componentName="Home page" />}
        >
            <Helmet>
                <title>LEIDSA | Lotería Electrónica Internacional Dominicana S.A.</title>
            </Helmet>
            <LayoutBase>
                <Hero />
                <Heading textStyle="titleTextAlt" as="h2" textAlign="center" my={12}>
                    {getText('global.title.drawResults', 'Draw Results')}
                </Heading>

                <Box
                    display="grid"
                    gridTemplateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)' }}
                    justifyContent="space-between"
                    gap={10}
                >
                    <RecentDrawsList />
                    <Box
                        display={{ base: 'none', lg: 'flex' }}
                        flexDirection="column"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Box display="flex" justifyContent="space-between">
                            <Box
                                background="white"
                                borderRadius="md"
                                width="48%"
                                textAlign="center"
                                padding={4}
                                boxShadow="md"
                            >
                                <Text
                                    scope="global"
                                    fontWeight="bold"
                                    color="red.600"
                                    tag="title.important"
                                    text="Important"
                                    fontSize="lg"
                                    textStyle="headingFontFamily"
                                />
                                <Text
                                    tag="paragraph.everyEffortPublishAllDrawResults"
                                    color="red.600"
                                    textStyle="semiBoldFontFamily"
                                    text="Every effort has been made to publish all draw results accurately. However, the official results located in the Leidsa files will be the ones that govern."
                                />
                            </Box>
                            <LinkBox
                                boxShadow="md"
                                borderRadius="md"
                                width="48%"
                                textAlign="center"
                                overflow="hidden"
                            >
                                <LinkOverlay as={ReachLink} to="scratchcards">
                                    <Image
                                        src={scratchcardImg}
                                        objectFit="fill"
                                        height="100%"
                                        width="100%"
                                    />
                                </LinkOverlay>
                            </LinkBox>
                        </Box>

                        <Image
                            src={logo}
                            maxWidth="auto"
                            height="50%"
                            maxHeight="250px"
                            alt="logo"
                        />
                    </Box>
                </Box>
            </LayoutBase>
        </Sentry.ErrorBoundary>
    )
}

export default HomePage
